export const siteContact = {
  phone: "+91 98185 84043",
  phoneHref: "tel:+919818584043",
  email: "info@algostine.com",
  emailHref: "mailto:info@algostine.com",
};
